import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { shouldNoIndex } from '../utils/seoRobots';

function SeoRobots() {
  const { pathname } = useLocation();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const noIndex = shouldNoIndex(pathname, hostname);

  return (
    <Helmet>
      <meta
        name="robots"
        content={noIndex ? 'noindex, nofollow' : 'index, follow'}
      />
    </Helmet>
  );
}

export default SeoRobots;
